import { PropsWithChildren } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { isReportUuid } from '../utils/reportRoute.util';

/**
 * Redirects non-UUID `:reportId` paths (e.g. Care Portal `/docket`) away from report APIs.
 * @param children - Report page content when the param is a valid UUID.
 */
const ReportIdParamGuard = ({ children }: PropsWithChildren) => {
  const { reportId } = useParams<{ reportId: string }>();

  if (!isReportUuid(reportId)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ReportIdParamGuard;
